import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../../assets/jss/components/tableStyle";
import { changePageTitle } from "../../../common/actions/CommonActions";
import { LOCALE } from "../../../properties/Locale";
import { VacancyAppRepository } from "../VacancyAppRepository";
import Card from "../../../common/components/Card/Card";
import CardHeader from "../../../common/components/Card/CardHeader";
import {
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Button,
  Icon,
  TableFooter,
  TablePagination,
} from "@material-ui/core";
import CardBody from "../../../common/components/Card/CardBody";
import moment from "moment";
import { Redirect } from "react-router-dom";

const useStyles = makeStyles(styles);

export default function EducationalCenterGradingDashboardComponent(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [btnSubmitLoading, setBtnSubmitLoading] = useState(false);
  const [rerender, triggerRerender] = React.useState(false);
  const [formDataErrors, setFormDataErrors] = useState();
  const [data, setData] = useState({
    totalElements: 0,
    number: 0,
    content: [],
  });
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [orderBy, setOrderBy] = useState("dateCreated");
  const [orderDirection, setOrderDirection] = useState("DESC");
  const [filterBy, setFilterBy] = useState();
  const [filterValue, setFilterValue] = useState();
  const [filterData, setFilterData] = useState({ name: "" });
  const globalState = useSelector((state) => state);
  const [redirect, setRedirect] = React.useState();

  const handleSubmit = () => {};

  useEffect(() => {
    dispatch(changePageTitle(LOCALE.educational_center_grading_dashboard));
    loadData(page, size, orderBy, orderDirection);
  }, []);

  const loadData = (page, size, orderBy, orderDirection) => {
    //TODO: Change this. Loaded dummy data.
    VacancyAppRepository.getAllForEvaluation({
      page: page,
      size: size,
      orderBy: orderBy,
      orderDirection: orderDirection,
      filterBy: "educationalCenterGradingStatus",
      filterValue: "PENDING",
    })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {});
  };

  React.useEffect(() => {
    VacancyAppRepository.getAllForEvaluation({
      page: page,
      size: size,
      orderBy: orderBy,
      orderDirection: orderDirection,
      filterBy: "educationalCenterGradingStatus",
      filterValue: "PENDING",
    })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {});
  }, [page, size]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setSize(parseInt(event.target.value, 10));
  };

  const handleFilterUserFieldChange = (name) => (event) => {
    setFilterData({ [name]: event.target.value });
    setFilterBy(name);
    setFilterValue(event.target.value);
  };

  const handleClickChangeOrderBy = (event) => {
    let orderValue = event.currentTarget.value;
    if (orderBy === orderValue) {
      if (orderDirection === "ASC") {
        setOrderDirection("DESC");
      } else {
        setOrderDirection("ASC");
      }
    } else {
      setOrderBy(orderValue);
      setOrderDirection("DESC");
    }
  };

  const openGrading = (vacancyAppId) => {
    setRedirect(
      "/app/grading/educationalCenter/vacancyApplication/" + vacancyAppId
    );
  };

  return (
    <div>
      {redirect && <Redirect to={redirect} />}

      <Card>
        <CardHeader color="theme">
          <Typography>{LOCALE.apps_for_educenter_evaluation}</Typography>
          <Typography style={{ float: "right" }}>
            {LOCALE.total_left}: {data?.totalElements}
          </Typography>
        </CardHeader>
        <CardBody>
          <Table aria-label="apps table" className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                <TableCell
                  style={{ fontWeight: "bold" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.vacancy}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.firstName}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.lastName}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.created_at}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.submissionDate}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.educationalCenterGradingStatus}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                  style={{
                    width: "100px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {LOCALE.actions}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.content && data.content.length === 0 && (
                <TableRow>
                  <TableCell colSpan={10}>
                    <Icon style={{ verticalAlign: "bottom", color: "orange" }}>
                      warning
                    </Icon>
                    {LOCALE.no_apps_for_evaluating}
                  </TableCell>
                </TableRow>
              )}
              {data &&
                data?.content.map((vacancyApp, index) => (
                  <TableRow
                    style={index % 2 === 1 ? { background: "#f0f0f0" } : {}}
                  >
                    <TableCell>{vacancyApp.vacancy.name}</TableCell>
                    <TableCell>{vacancyApp?.basicInfo?.firstName}</TableCell>
                    <TableCell>{vacancyApp?.basicInfo?.lastName}</TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {vacancyApp.dateCreated &&
                        moment(vacancyApp.dateCreated).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {vacancyApp.submissionDate &&
                        moment(vacancyApp.submissionDate).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )}
                    </TableCell>

                    <TableCell style={{ textAlign: "center" }}>
                      {vacancyApp.educationalCenterGradingStatus &&
                        vacancyApp.educationalCenterGradingStatus ===
                          "PENDING" && (
                          <Chip
                            label={LOCALE.getString("PENDING")}
                            style={{
                              color: "white",
                              backgroundColor: "orange",
                            }}
                          />
                        )}
                      {vacancyApp.educationalCenterGradingStatus &&
                        vacancyApp.educationalCenterGradingStatus ===
                          "PROCESSING" && (
                          <Chip
                            label={LOCALE.getString("PROCESSING")}
                            color="primary"
                          />
                        )}
                      {vacancyApp.educationalCenterGradingStatus &&
                        vacancyApp.educationalCenterGradingStatus ===
                          "DONE" && (
                          <Chip
                            label={LOCALE.getString("DONE")}
                            style={{
                              color: "white",
                              backgroundColor: "green",
                            }}
                          />
                        )}
                    </TableCell>
                    <TableCell>
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        onClick={() => openGrading(vacancyApp.id)}
                      >
                        <Icon size={10}>edit</Icon> &nbsp;
                        {LOCALE.grade}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  colSpan={7}
                  count={data?.totalElements}
                  rowsPerPage={size}
                  page={data?.number}
                  labelRowsPerPage={LOCALE.rows_per_page}
                  SelectProps={{
                    inputProps: { "aria-label": LOCALE.rows_per_page },
                    native: true,
                  }}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </CardBody>
      </Card>
    </div>
  );
}
